<template>
  <div>
    <div v-if="verticalList">
      {{ items.join(', ' ) }}
    </div>


    <div
      v-for="(item, index) in items"
      v-else
      :key="index"
    >
      {{ item }}
    </div>
  </div>
</template>

<script>
export default {
    props: {
        items: {
            type: Array,
            default: () => [],
        },
        verticalList: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
